import { createRouter, createWebHistory } from "vue-router";
import Top from "./components/HomePage.vue";
import Product from "./components/ProductPage.vue";

const routes = [
  {
    path: "/",
    name: "top",
    component: Top,
  },
  {
    path: "/product",
    name: "product",
    component: Product,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  // base: "/ttttest/dist/", // ベースURLを設定
  //base: "/toho_w_p/", // ベースURLを設定
  routes,
});
export default router;
